import _SDObject from "./SDObject";
var exports = {};
var __classPrivateFieldGet = exports && exports.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = exports && exports.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var _SDData_SDtype;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SDData = exports.SD_DATA_TYPE = void 0;
const SDObject_1 = _SDObject;
var SD_DATA_TYPE;
(function (SD_DATA_TYPE) {
  SD_DATA_TYPE["GEOMETRY"] = "geometry";
  SD_DATA_TYPE["MATERIAL"] = "material";
  SD_DATA_TYPE["THREEJS"] = "threejs";
  SD_DATA_TYPE["LIGHT"] = "light";
  SD_DATA_TYPE["CAMERA"] = "camera";
  SD_DATA_TYPE["ANIMATION"] = "animation";
  SD_DATA_TYPE["INTERACTION"] = "interaction";
  SD_DATA_TYPE["HTML_ELEMENT_ANCHOR"] = "html_element_anchor";
  SD_DATA_TYPE["CUSTOM"] = "custom";
})(SD_DATA_TYPE = exports.SD_DATA_TYPE || (exports.SD_DATA_TYPE = {}));
class SDData extends SDObject_1.SDObject {
  // #endregion Properties (1)
  // #region Constructors (1)
  constructor(SDid, SDversion) {
    super(SDid, SDversion);
    // #region Properties (1)
    _SDData_SDtype.set(this, SD_DATA_TYPE.CUSTOM);
  }
  // #endregion Constructors (1)
  // #region Public Accessors (2)
  get SDtype() {
    return __classPrivateFieldGet(this, _SDData_SDtype, "f");
  }
  set SDtype(value) {
    __classPrivateFieldSet(this, _SDData_SDtype, value, "f");
  }
}
exports.SDData = SDData;
_SDData_SDtype = new WeakMap();
//# sourceMappingURL=SDData.js.map
export default exports;